import { createFileRoute } from '@tanstack/react-router';
import { BrokerBranchesPage } from '@/features/broker-branches/BrokerBranchesPage';

export const Route = createFileRoute('/$market/securities/$symbol/broker-branches')({
  component: BrokerBranchesRoute,
});

function BrokerBranchesRoute() {
  const { symbol } = Route.useParams();
  return <BrokerBranchesPage symbol={symbol} />;
}
